// extracted by mini-css-extract-plugin
export default {"aside":"wovok","wrapper":"dEq06","input":"CXgzD"};